import type {RutaProd} from '../../../../runtime/rutas';
export default {ruta:"/sistema/catalogos",documento:'catalogs',acceso:'sesion',filas:['160'],cita:'Areas/Catalogs/Controllers/DashboardController.cs:39',alias:['/sistema/catalogos/dashboard']} satisfies RutaProd;
